<!-- [コンテンツ領域2カラム] -->
<div class="l-core-contents__inner">
  <!-- [コンテンツ領域2カラム−メイン] -->
  <!-- [コンテンツ領域2カラム−サブ] -->
  <div class="l-core-contents__sub">
    <asw-service-request-payment-input-payment-amount></asw-service-request-payment-input-payment-amount>
  </div>
  <!-- //[コンテンツ領域2カラム−サブ] -->
  <div class="l-core-contents__main">
    <div class="l-section u-mt-sp-20 u-mt-tb-24 u-mt-pc-40">
      <!-- //[見出し領域] -->
      <form [formGroup]="deviceIdFormGroup">
        <input type="hidden" id="blackBox" formControlName="blackBox" />
      </form>

      <div [formGroup]="paymentInputFG" class="l-tab-menu01 js-tab-menu01" data-visually="cc">
        <asw-service-request-payment-input-payment-methods></asw-service-request-payment-input-payment-methods>
        <div class="l-tab-menu01__body">
          <!-- //[l-tab-menu01__contents] -->
          <!-- [l-tab-menu01__contents]タブの中身 -->
          <div
            *ngIf="isDisplayCreditCard"
            [ngClass]="['l-tab-menu01__contents', isDisplayCreditCard ? 'is-current' : '']"
            id="panel-cc"
            role="tabpanel"
            aria-labelledby="tab-cc"
            tabindex="0"
          >
            <asw-service-request-payment-input-credit-card></asw-service-request-payment-input-credit-card>
          </div>
          <!-- //[l-tab-menu01__contents] -->
          <!-- [l-tab-menu01__contents]タブの中身 -->
          <!-- [7.1] PayPalに関する案内文言 -->
          <div
            *ngIf="isDisplayPayPal"
            [ngClass]="['l-tab-menu01__contents', isDisplayPayPal ? 'is-current' : '']"
            id="panel-paypal"
            role="tabpanel"
            aria-labelledby="tab-paypal"
            tabindex="0"
          >
            <h3
              class="p-payment-method-paypal__item-title p-payment-method-paypal__item-title--m"
              [innerHTML]="'label.paypal' | staticMsg"
            ></h3>
            <div
              class="p-payment-method-paypal__item-contents"
              [innerHTML]="'message.paypalDescription' | staticMsg"
            ></div>
          </div>
          <!-- //[l-tab-menu01__contents] -->
          <!-- [l-tab-menu01__contents]タブの中身 -->
          <!-- [4.1] Alipayに関する案内文言 -->
          <div
            *ngIf="isDisplayAlipay"
            [ngClass]="['l-tab-menu01__contents', isDisplayAlipay ? 'is-current' : '']"
            id="panel-alipay"
            role="tabpanel"
            aria-labelledby="tab-alipay"
            tabindex="0"
          >
            <h3
              class="p-payment-method-alipay__item-title p-payment-method-alipay__item-title--m"
              [innerHTML]="'label.alipay' | staticMsg"
            ></h3>
            <div
              class="p-payment-method-alipay__item-contents"
              [innerHTML]="'message.alipayDescription' | staticMsg"
            ></div>
          </div>
          <!-- //[l-tab-menu01__contents] -->
          <!-- [l-tab-menu01__contents]タブの中身 -->
          <!-- [5.1] 銀聯に関する案内文言 -->
          <div
            *ngIf="isDispalyChinaUnionPay"
            [ngClass]="['l-tab-menu01__contents', isDispalyChinaUnionPay ? 'is-current' : '']"
            id="panel-unionpay"
            role="tabpanel"
            aria-labelledby="tab-unionpay"
            tabindex="0"
          >
            <h3
              class="p-payment-method-unionpay__item-title p-payment-method-unionpay__item-title--m"
              [innerHTML]="'heading.cup' | staticMsg"
            ></h3>
            <div
              class="p-payment-method-unionpay__item-contents"
              [innerHTML]="'message.cupDescription' | staticMsg"
            ></div>
          </div>
        </div>
      </div>
      <!-- //[l-tab-menu01] -->
    </div>
    <!-- //[l-section] -->
    <div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
      <asw-service-request-payment-input-notification
        *ngIf="isDisplayNotification"
      ></asw-service-request-payment-input-notification>
    </div>
    <!-- //[l-section] -->
    <!-- [1.12] 支払規約 -->
    <div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
      <asw-agreement-area
        #agreement
        [agreementAreaParts]="agreementAreaParams"
        (submitEvent)="clickAgree()"
      ></asw-agreement-area>
    </div>
    <!-- //[l-section] -->
  </div>
  <!-- //[コンテンツ領域2カラム−メイン] -->
</div>
